import React, { useEffect, useMemo, useRef, useState } from "react";

const Preloader = ({ images = [], onDone, timeoutMs = 8000 }) => {
    const [loadedCount, setLoadedCount] = useState(0);
    const total = images.length;
    const doneRef = useRef(false);

    const progress = total > 0 ? Math.round((loadedCount / total) * 100) : 100;

    const uniqueImages = useMemo(
        () => Array.from(new Set(images.filter(Boolean))),
        [images]
    );

    useEffect(() => {
        if (uniqueImages.length === 0) {
            if (!doneRef.current) {
                doneRef.current = true;
                onDone?.();
            }
            return;
        }

        let cancelled = false;
        const controller = new AbortController();

        const load = (url) =>
            new Promise((resolve) => {
                const img = new Image();
                const finish = () => resolve();
                img.onload = finish;
                img.onerror = finish;
                img.src = url;
            });

        const start = async () => {
            for (const url of uniqueImages) {
                if (cancelled) break;
                try {
                    await load(url);
                } finally {
                    setLoadedCount((c) => c + 1);
                }
            }
            if (!cancelled && !doneRef.current) {
                doneRef.current = true;
                onDone?.();
            }
        };

        const t = window.setTimeout(() => {
            if (!doneRef.current) {
                doneRef.current = true;
                onDone?.();
            }
        }, timeoutMs);

        start();

        return () => {
            cancelled = true;
            controller.abort();
            window.clearTimeout(t);
        };
    }, [uniqueImages, onDone, timeoutMs]);

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
            <div className="text-center">
                <div className="w-56 h-2 bg-gray-200 rounded overflow-hidden mb-3">
                    <div
                        className="h-full bg-[#FFD700] transition-all"
                        style={{ width: `${progress}%` }}
                    />
                </div>
                <div className="text-gray-700 text-sm font-medium">
                    Loading {progress}%
                </div>
            </div>
        </div>
    );
};

export default Preloader;
